module.exports = __webpack_public_path__ + "img/pla_LZDSG.af312d11.png";